var _dec, _class;
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;
  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }
  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);
  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }
  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }
  return desc;
}
import { formatDate as _formatDate, isFutureDate, isLessThanOneHourAgo, isLessThanOneMinuteAgo, isLessThanOneWeekAgo, isLessThanOneYearAgo, isToday, isTomorrow, isYesterday, TimeUnit, isLessThanOneWeekAway, isLessThanOneYearAway } from '@shopify/dates';
import { memoize } from '@shopify/decorators';
import { languageFromLocale, regionFromLocale } from '@shopify/i18n';
import { LanguageDirection } from "./types.mjs";
import { dateStyle, DateStyle, DEFAULT_WEEK_START_DAY, WEEK_START_DAYS, RTL_LANGUAGES, currencyDecimalPlaces, DEFAULT_DECIMAL_PLACES, EASTERN_NAME_ORDER_FORMATTERS } from "./constants/index.mjs";
import { MissingCurrencyCodeError, MissingCountryError } from "./errors.mjs";
import { getCurrencySymbol, translate as _translate, getTranslationTree as _getTranslationTree, memoizedNumberFormatter, memoizedPluralRules } from "./utilities/index.mjs";
// Used for currecies that don't use fractional units (eg. JPY)
var DECIMAL_NOT_SUPPORTED = 'N/A';
var PERIOD = '.';
var DECIMAL_VALUE_FOR_CURRENCIES_WITHOUT_DECIMALS = '00';
export var I18n = (_dec = memoize(), _class = /*#__PURE__*/function () {
  function I18n(translations, _ref) {
    var _this = this;
    var locale = _ref.locale,
      _currency = _ref.currency,
      timezone = _ref.timezone,
      country = _ref.country,
      _ref$pseudolocalize = _ref.pseudolocalize,
      pseudolocalize = _ref$pseudolocalize === void 0 ? false : _ref$pseudolocalize,
      onError = _ref.onError,
      loading = _ref.loading;
    _classCallCheck(this, I18n);
    this.translations = translations;
    this.locale = void 0;
    this.pseudolocalize = void 0;
    this.defaultCountry = void 0;
    this.defaultCurrency = void 0;
    this.defaultTimezone = void 0;
    this.onError = void 0;
    this.loading = void 0;
    this.getCurrencySymbol = function (currencyCode) {
      var currency = currencyCode || _this.defaultCurrency;
      if (currency == null) {
        throw new MissingCurrencyCodeError('formatCurrency cannot be called without a currency code.');
      }
      return _this.getCurrencySymbolLocalized(_this.locale, currency);
    };
    this.locale = locale;
    this.defaultCountry = country;
    this.defaultCurrency = _currency;
    this.defaultTimezone = timezone;
    this.pseudolocalize = pseudolocalize;
    this.onError = onError || defaultOnError;
    this.loading = loading || false;
  }
  _createClass(I18n, [{
    key: "language",
    get: function get() {
      return languageFromLocale(this.locale);
    }
  }, {
    key: "region",
    get: function get() {
      return regionFromLocale(this.locale);
    }
    /**
     * @deprecated Use I18n#region instead.
     */
  }, {
    key: "countryCode",
    get: function get() {
      return regionFromLocale(this.locale);
    }
  }, {
    key: "languageDirection",
    get: function get() {
      return RTL_LANGUAGES.includes(this.language) ? LanguageDirection.Rtl : LanguageDirection.Ltr;
    }
  }, {
    key: "isRtlLanguage",
    get: function get() {
      return this.languageDirection === LanguageDirection.Rtl;
    }
  }, {
    key: "isLtrLanguage",
    get: function get() {
      return this.languageDirection === LanguageDirection.Ltr;
    }
  }, {
    key: "translate",
    value: function translate(id, optionsOrReplacements, replacements) {
      var pseudolocalize = this.pseudolocalize;
      var normalizedOptions;
      if (optionsOrReplacements == null) {
        normalizedOptions = {
          pseudotranslate: pseudolocalize
        };
      } else if (isTranslateOptions(optionsOrReplacements)) {
        normalizedOptions = _objectSpread(_objectSpread({}, optionsOrReplacements), {}, {
          replacements: replacements,
          pseudotranslate: pseudolocalize
        });
      } else {
        normalizedOptions = {
          replacements: optionsOrReplacements,
          pseudotranslate: pseudolocalize
        };
      }
      try {
        return _translate(id, normalizedOptions, this.translations, this.locale);
      } catch (error) {
        this.onError(error);
        return '';
      }
    }
  }, {
    key: "getTranslationTree",
    value: function getTranslationTree(id, replacements) {
      try {
        if (!replacements) {
          return _getTranslationTree(id, this.translations, this.locale);
        }
        return _getTranslationTree(id, this.translations, this.locale, replacements);
      } catch (error) {
        this.onError(error);
        return '';
      }
    }
  }, {
    key: "translationKeyExists",
    value: function translationKeyExists(id) {
      try {
        _getTranslationTree(id, this.translations, this.locale);
        return true;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(amount) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        as = _ref2.as,
        precision = _ref2.precision,
        options = _objectWithoutProperties(_ref2, ["as", "precision"]);
      var locale = this.locale,
        currency = this.defaultCurrency;
      if (as === 'currency' && currency == null && options.currency == null) {
        this.onError(new MissingCurrencyCodeError("formatNumber(amount, {as: 'currency'}) cannot be called without a currency code."));
        return '';
      }
      return memoizedNumberFormatter(locale, _objectSpread({
        style: as,
        maximumFractionDigits: precision,
        currency: currency
      }, options)).format(amount);
    }
  }, {
    key: "unformatNumber",
    value: function unformatNumber(input) {
      var _this$numberSymbols = this.numberSymbols(),
        thousandSymbol = _this$numberSymbols.thousandSymbol,
        decimalSymbol = _this$numberSymbols.decimalSymbol;
      var normalizedValue = normalizedNumber(input, decimalSymbol, thousandSymbol === PERIOD);
      return normalizedValue === '' ? '' : parseFloat(normalizedValue).toString();
    }
  }, {
    key: "formatCurrency",
    value: function formatCurrency(amount) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        form = _ref3.form,
        options = _objectWithoutProperties(_ref3, ["form"]);
      switch (form) {
        case 'auto':
          return this.formatCurrencyAuto(amount, options);
        case 'explicit':
          return this.formatCurrencyExplicit(amount, options);
        case 'short':
          return this.formatCurrencyShort(amount, options);
        case 'none':
          return this.formatCurrencyNone(amount, options);
      }
      return this.formatNumber(amount, _objectSpread({
        as: 'currency'
      }, options));
    }
  }, {
    key: "unformatCurrency",
    value: function unformatCurrency(input, currencyCode) {
      // This decimal symbol will always be '.' regardless of the locale
      // since it's our internal representation of the string
      var decimalSymbol = this.currencyDecimalSymbol(currencyCode);
      var expectedDecimalSymbol = decimalSymbol === DECIMAL_NOT_SUPPORTED ? PERIOD : decimalSymbol;
      var normalizedValue = normalizedNumber(input, expectedDecimalSymbol);
      if (normalizedValue === '') {
        return '';
      }
      if (decimalSymbol === DECIMAL_NOT_SUPPORTED) {
        var roundedAmount = parseFloat(normalizedValue).toFixed(0);
        return "".concat(roundedAmount, ".").concat(DECIMAL_VALUE_FOR_CURRENCIES_WITHOUT_DECIMALS);
      }
      var decimalPlaces = currencyDecimalPlaces.get(currencyCode.toUpperCase()) || DEFAULT_DECIMAL_PLACES;
      return parseFloat(normalizedValue).toFixed(decimalPlaces);
    }
  }, {
    key: "formatPercentage",
    value: function formatPercentage(amount) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.formatNumber(amount, _objectSpread({
        as: 'percent'
      }, options));
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var locale = this.locale,
        defaultTimezone = this.defaultTimezone;
      var _options$timeZone = options.timeZone,
        timeZone = _options$timeZone === void 0 ? defaultTimezone : _options$timeZone;
      var _ref4 = options || {},
        _ref4$style = _ref4.style,
        style = _ref4$style === void 0 ? undefined : _ref4$style,
        formatOptions = _objectWithoutProperties(_ref4, ["style"]);
      if (style) {
        return style === DateStyle.Humanize ? this.humanizeDate(date, _objectSpread(_objectSpread({}, formatOptions), {}, {
          timeZone: timeZone
        })) : this.formatDate(date, _objectSpread(_objectSpread({}, formatOptions), dateStyle[style]));
      }
      return _formatDate(date, locale, _objectSpread(_objectSpread({}, formatOptions), {}, {
        timeZone: timeZone
      }));
    }
  }, {
    key: "ordinal",
    value: function ordinal(amount) {
      var locale = this.locale;
      var group = memoizedPluralRules(locale, {
        type: 'ordinal'
      }).select(amount);
      return this.translate(group, {
        scope: 'ordinal'
      }, {
        amount: amount
      });
    }
  }, {
    key: "weekStartDay",
    value: function weekStartDay(argCountry) {
      var country = argCountry || this.defaultCountry;
      if (!country) {
        throw new MissingCountryError('weekStartDay() cannot be called without a country code.');
      }
      return WEEK_START_DAYS.get(country) || DEFAULT_WEEK_START_DAY;
    }
  }, {
    key: "getCurrencySymbolLocalized",
    value: function getCurrencySymbolLocalized(locale, currency) {
      return getCurrencySymbol(locale, {
        currency: currency
      });
    }
  }, {
    key: "formatName",
    value: function formatName(firstName, lastName, options) {
      if (!firstName) {
        return lastName || '';
      }
      if (!lastName) {
        return firstName;
      }
      var isFullName = Boolean(options && options.full);
      var customNameFormatter = EASTERN_NAME_ORDER_FORMATTERS.get(this.locale) || EASTERN_NAME_ORDER_FORMATTERS.get(this.language);
      if (customNameFormatter) {
        return customNameFormatter(firstName, lastName, isFullName);
      }
      if (isFullName) {
        return "".concat(firstName, " ").concat(lastName);
      }
      return firstName;
    }
  }, {
    key: "hasEasternNameOrderFormatter",
    value: function hasEasternNameOrderFormatter() {
      var easternNameOrderFormatter = EASTERN_NAME_ORDER_FORMATTERS.get(this.locale) || EASTERN_NAME_ORDER_FORMATTERS.get(this.language);
      return Boolean(easternNameOrderFormatter);
    }
  }, {
    key: "numberSymbols",
    value: function numberSymbols() {
      var formattedNumber = this.formatNumber(123456.7, {
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
      });
      var thousandSymbol;
      var decimalSymbol;
      var _iterator = _createForOfIteratorHelper(formattedNumber),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _char = _step.value;
          if (isNaN(parseInt(_char, 10))) {
            if (thousandSymbol) decimalSymbol = _char;else thousandSymbol = _char;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        thousandSymbol: thousandSymbol,
        decimalSymbol: decimalSymbol
      };
    }
  }, {
    key: "formatCurrencyAuto",
    value: function formatCurrencyAuto(amount) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // use the short format if we can't determine a currency match, or if the
      // currencies match, use explicit when the currencies definitively do not
      // match.
      var formatShort = options.currency == null || this.defaultCurrency == null || options.currency === this.defaultCurrency;
      return formatShort ? this.formatCurrencyShort(amount, options) : this.formatCurrencyExplicit(amount, options);
    }
  }, {
    key: "formatCurrencyExplicit",
    value: function formatCurrencyExplicit(amount) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var value = this.formatCurrencyShort(amount, options);
      var isoCode = options.currency || this.defaultCurrency || '';
      if (value.includes(isoCode)) {
        return value;
      }
      return "".concat(value, " ").concat(isoCode);
    }
  }, {
    key: "formatCurrencyShort",
    value: function formatCurrencyShort(amount) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var formattedAmount = this.formatCurrencyNone(amount, options);
      var shortSymbol = this.getShortCurrencySymbol(options.currency);
      var formattedWithSymbol = shortSymbol.prefixed ? "".concat(shortSymbol.symbol).concat(formattedAmount) : "".concat(formattedAmount).concat(shortSymbol.symbol);
      return amount < 0 ? "-".concat(formattedWithSymbol.replace('-', '')) : formattedWithSymbol;
    }
  }, {
    key: "formatCurrencyNone",
    value: function formatCurrencyNone(amount) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var locale = this.locale;
      var adjustedPrecision = options.precision;
      if (adjustedPrecision === undefined) {
        var currency = options.currency || this.defaultCurrency || '';
        adjustedPrecision = currencyDecimalPlaces.get(currency.toUpperCase());
      }
      return memoizedNumberFormatter(locale, _objectSpread({
        style: 'decimal',
        minimumFractionDigits: adjustedPrecision,
        maximumFractionDigits: adjustedPrecision
      }, options)).format(amount);
    } // Intl.NumberFormat sometimes annotates the "currency symbol" with a country code.
    // For example, in locale 'fr-FR', 'USD' is given the "symbol" of " $US".
    // This method strips out the country-code annotation, if there is one.
    // (So, for 'fr-FR' and 'USD', the return value would be " $").
    //
    // For other currencies, e.g. CHF and OMR, the "symbol" is the ISO currency code.
    // In those cases, we return the full currency code without stripping the country.
  }, {
    key: "getShortCurrencySymbol",
    value: function getShortCurrencySymbol() {
      var currencyCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultCurrency || '';
      var currency = currencyCode || this.defaultCurrency || '';
      var regionCode = currency.substring(0, 2);
      var info = this.getCurrencySymbol(currency);
      var shortSymbol = info.symbol.replace(regionCode, '');
      var alphabeticCharacters = /[A-Za-zÀ-ÖØ-öø-ÿĀ-ɏḂ-ỳ]/;
      return alphabeticCharacters.exec(shortSymbol) ? info : {
        symbol: shortSymbol,
        prefixed: info.prefixed
      };
    }
  }, {
    key: "humanizeDate",
    value: function humanizeDate(date, options) {
      if (isFutureDate(date)) {
        return this.humanizeFutureDate(date, options);
      } else {
        return this.humanizePastDate(date, options);
      }
    }
  }, {
    key: "humanizePastDate",
    value: function humanizePastDate(date, options) {
      if (isLessThanOneMinuteAgo(date)) {
        return this.translate('date.humanize.lessThanOneMinuteAgo');
      }
      if (isLessThanOneHourAgo(date)) {
        var now = new Date();
        var minutes = Math.floor((now.getTime() - date.getTime()) / TimeUnit.Minute);
        return this.translate('date.humanize.lessThanOneHourAgo', {
          count: minutes
        });
      }
      var timeZone = options === null || options === void 0 ? void 0 : options.timeZone;
      var time = this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
        hour: 'numeric',
        minute: '2-digit'
      })).toLocaleLowerCase();
      if (isToday(date, timeZone)) {
        return time;
      }
      if (isYesterday(date, timeZone)) {
        return this.translate('date.humanize.yesterday', {
          time: time
        });
      }
      if (isLessThanOneWeekAgo(date)) {
        var weekday = this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
          weekday: 'long'
        }));
        return this.translate('date.humanize.lessThanOneWeekAgo', {
          weekday: weekday,
          time: time
        });
      }
      if (isLessThanOneYearAgo(date)) {
        var monthDay = this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
          month: 'short',
          day: 'numeric'
        }));
        return this.translate('date.humanize.lessThanOneYearAgo', {
          date: monthDay,
          time: time
        });
      }
      return this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
        style: DateStyle.Short
      }));
    }
  }, {
    key: "humanizeFutureDate",
    value: function humanizeFutureDate(date, options) {
      var timeZone = options === null || options === void 0 ? void 0 : options.timeZone;
      var time = this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
        hour: 'numeric',
        minute: '2-digit'
      })).toLocaleLowerCase();
      if (isToday(date, timeZone)) {
        return this.translate('date.humanize.today', {
          time: time
        });
      }
      if (isTomorrow(date, timeZone)) {
        return this.translate('date.humanize.tomorrow', {
          time: time
        });
      }
      if (isLessThanOneWeekAway(date)) {
        var weekday = this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
          weekday: 'long'
        }));
        return this.translate('date.humanize.lessThanOneWeekAway', {
          weekday: weekday,
          time: time
        });
      }
      if (isLessThanOneYearAway(date)) {
        var monthDay = this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
          month: 'short',
          day: 'numeric'
        }));
        return this.translate('date.humanize.lessThanOneYearAway', {
          date: monthDay,
          time: time
        });
      }
      return this.formatDate(date, _objectSpread(_objectSpread({}, options), {}, {
        style: DateStyle.Short
      }));
    }
  }, {
    key: "currencyDecimalSymbol",
    value: function currencyDecimalSymbol(currencyCode) {
      var digitOrSpace = /\s|\d/g;
      var _this$getCurrencySymb = this.getCurrencySymbolLocalized(this.locale, currencyCode),
        symbol = _this$getCurrencySymb.symbol;
      var templatedInput = 1;
      var decimal = this.formatCurrency(templatedInput, {
        currency: currencyCode,
        form: 'short'
      }).replace(symbol, '').replace(digitOrSpace, '');
      return decimal.length === 0 ? DECIMAL_NOT_SUPPORTED : decimal;
    }
  }]);
  return I18n;
}(), _applyDecoratedDescriptor(_class.prototype, "numberSymbols", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "numberSymbols"), _class.prototype), _class);
function normalizedNumber(input, expectedDecimal, usesPeriodThousandSymbol) {
  var nonDigits = /\D/g; // For locales that use non-period symbols as the decimal symbol, users may still input a period
  // and expect it to be treated as the decimal symbol for their locale.

  var hasExpectedDecimalSymbol = input.lastIndexOf(expectedDecimal) !== -1;
  var hasPeriodAsDecimal = input.lastIndexOf(PERIOD) !== -1;
  var usesPeriodDecimal = !usesPeriodThousandSymbol && !hasExpectedDecimalSymbol && hasPeriodAsDecimal;
  var decimalSymbolToUse = usesPeriodDecimal ? PERIOD : expectedDecimal;
  var lastDecimalIndex = input.lastIndexOf(decimalSymbolToUse);
  var integerValue = input.substring(0, lastDecimalIndex).replace(nonDigits, '');
  var decimalValue = input.substring(lastDecimalIndex + 1).replace(nonDigits, '');
  var isNegative = input.trim().startsWith('-');
  var negativeSign = isNegative ? '-' : '';
  var normalizedDecimal = lastDecimalIndex === -1 ? '' : PERIOD;
  var normalizedValue = "".concat(negativeSign).concat(integerValue).concat(normalizedDecimal).concat(decimalValue);
  return normalizedValue === '' || normalizedValue === PERIOD ? '' : normalizedValue;
}
function isTranslateOptions(object) {
  return 'scope' in object;
}
function defaultOnError(error) {
  throw error;
}